import { UserType } from '../../Session/SessionProvider';
import { type PageDetailsMapping } from '../types/propTypes';

const userProfileRegistry: PageDetailsMapping = {
  [UserType.ANONYMOUS]: 'guest',
  [UserType.REGISTERED]: 'customer',
  [UserType.ABO]: 'abo',
  [UserType.MEMBER]: 'member',
};

export default userProfileRegistry;
